import axiosClient from "./axiosClient";

// type paramProps {
//   page?: number,
//   size?:number ,

// };

// const serviceUrl = "http://42.96.44.215:10002";
// http://42.96.44.215:10002/qlkhambenh/refraction/list-refraction?page=1&size=10
const refraction = {
  getLitReceived: async (params) => {
    const url = "/qlkhambenh/refraction/list-refraction";
    const response = await axiosClient.get(url, { params: params });

    return response.data;
  },
  getLitReceivedById: async (id) => {
    const url = `/qlkhambenh/refraction/id?id=${id}`;
    const response = await axiosClient.get(url);
    return response.data;
  },
  updateDetails: async (data) => {
    const url = "/qlkhambenh/refraction";
    const response = await axiosClient.put(url, data);
    return response.data;
  },
  deleteAPatient: async (id) => {
    const url = "/qlkhambenh/refraction";
    const response = await axiosClient.delete(url, { params: { id } });
    return response;
  },
  updateStatus: async (data) => {
    const url = "/qlkhambenh/refraction/update_status";
    const response = await axiosClient.put(url, data);
    return response;
  },
  updateStatusPK: async (param) => {
    const url = "/qlkhambenh/phieu-kham/cap-nhat-trang-thai";
    const response = await axiosClient.put(url, {}, { params: param });
    return response;
  },
  getNextPatient: async () => {
    const url = "/qlkhambenh/refraction/benh-nhan-tiep-theo";
    const id = await axiosClient.get(url);
    return id;
  },
  //tra thuoc
  getListDilate: async () => {
    const url = `/qlkhambenh/dm-thuoc-tra/list-dm-thuoc-tra?type=0`;
    const response = await axiosClient.get(url);
    return response.data;
  },

  postListDilate: async (data) => {
    const url = `/qlkhambenh/tra-thuoc`;
    const response = await axiosClient.post(url, data);
    return response.data;
  },

  putListDilate: async (id, data) => {
    const url = `/qlkhambenh/tra-thuoc?id=${id}`;
    const response = await axiosClient.put(url, data);
    return response.data;
  },

  //otthorK
  getListDataOthorK: async (params) => {
    const url = `/qlkhambenh/orthok-monitor/list-monitor`;
    const response = await axiosClient.get(url, { params: params });
    return response.data;
  },
  getByIdOthorK: async (id) => {
    const url = `/qlkhambenh/orthok-monitor/id?id=${id}`;
    const response = await axiosClient.get(url);
    return response.data;
  },
  putOthorK: async (data) => {
    const url = `/qlkhambenh/orthok-monitor`;
    const response = await axiosClient.put(url, data);
    return response.data;
  },
  postOthorK: async (data) => {
    const url = `/qlkhambenh/orthok-monitor`;
    const response = await axiosClient.post(url, data);
    return response.data;
  },

  deleteByIdOthorK: async (id) => {
    const url = `/qlkhambenh/orthok-monitor?id=${id}`;
    const response = await axiosClient.delete(url);
    return response.data;
  },
};

export default refraction;
